export const SET_PRESENT_ORDERS = "SET_PRESENT_ORDERS";
export const SET_PAST_ORDERS = "SET_PAST_ORDERS";
export const SET_PRESENT_ORDER_NUM = "SET_PRESENT_ORDER_NUM";
